<template>
    <v-menu
        ref="datePicker"
        v-model="datePicker"
        :close-on-content-click="false"
        :return-value.sync="dob"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                aria-required
                required
                v-model="dob"
                v-bind="$attrs"
                name="date of birth"
                label="Date of birth"
                append-icon="mdi-calendar"
                @click:append="datePicker = true"
                v-on="on"
                background-color="#f8f8fd"
                color="primary"
                outlined
                autocomplete="off"
                readonly
                :disabled="disabled"
            ></v-text-field>
        </template>
        <v-date-picker
            ref="picker"
            v-model="dob"
            color="primary"
            :max="getDateEighteenYearsAgo().toISOString().substr(0, 10)"
            min="1903-01-01"
            :disabled="disabled"
            @change="$refs.datePicker.save(dob)"
        ></v-date-picker>
    </v-menu>
</template>


<script>
export default {
    props: {
        value: String,
        disabled: {
           type: Boolean,
           default: false,
        }
    },
    data() {
        return {
            dob: null,
            datePicker: false,
            year: Vue.moment().year(),
        };
    },
    mounted() {
        this.dob = this.value ? Vue.moment(this.value).format('YYYY-MM-DD') : null;
    },
    watch: {
        value: function (val) {
            this.dob = val ? Vue.moment(val).format('YYYY-MM-DD') : null;
        },
        datePicker: function (val) {
            val && setTimeout(() => {
                this.$refs.picker.activePicker = 'YEAR'
            });
        },
        dob: function(val) {
            setTimeout(() => {
                if (val.dob >= 1903 && val.dob <= this.year - 18) {
                    this.scrollToActiveYear(val);
                }
            }, 1);
            this.$emit('input', val);
        },
    },
    methods: getMethods(),
};

function getMethods() {
    return {
        getDateEighteenYearsAgo,
        scrollToActiveYear,
    };

    function getDateEighteenYearsAgo() {
        return Vue.moment().subtract(18, 'years');
    }

    function scrollToActiveYear() {
        const yearList = document.getElementsByClassName("v-date-picker-years")[0];
        const activeYear = document.getElementsByClassName("active")[0];


        scrollToElm( yearList, activeYear , .5 );

        function scrollToElm(container, elm, duration){
            let pos = getRelativePos(elm);
            console.log(pos);
            scrollTo( container, pos.top , duration);  // duration in seconds
        }

        function getRelativePos(elm){
            let pPos = elm.parentNode.getBoundingClientRect(), // parent pos
                cPos = elm.getBoundingClientRect(), // target pos
                pos = {};

            pos.top    = cPos.top    - pPos.top + elm.parentNode.scrollTop,
            pos.right  = cPos.right  - pPos.right,
            pos.bottom = cPos.bottom - pPos.bottom,
            pos.left   = cPos.left   - pPos.left;

            return pos;
        }

        function scrollTo(element, to, duration, onDone) {
            var start = element.scrollTop,
                change = to - start,
                startTime = performance.now(),
                val, now, elapsed, t;

            function animateScroll(){
                now = performance.now();
                elapsed = (now - startTime)/1000;
                t = (elapsed/duration);

                element.scrollTop = start + change * easeInOutQuad(t);

                if( t < 1 )
                    window.requestAnimationFrame(animateScroll);
                else
                    onDone && onDone();
            };

            animateScroll();
        }

        function easeInOutQuad(t){ return t<.5 ? 2*t*t : -1+(4-2*t)*t };
    }
}
</script>
